import {accountWithRoles as accountRoleConversionUtils} from './accountconversion';
import {get, post, paginatedAll} from './utils';
import configConversionUtils from './configconversion';
import smbUtils from '../utils/smbUtils';

const dao = {
  queryEngagement: () =>
    get('/smb-backend/customer/query-customer-engagement.action'),
  createCustomerEngagement: behaviorType =>
    post('/smb-backend/customer/create-customer-engagement.action', {
      behaviorType,
    }),
  createCustomerSession: solutionType =>
    get('/smb-backend/customer/create-customer-session.action?', {
      solutionType,
    }),
  queryAccountSummary: async () => {
    let account = dao.queryAccount();
    let customer = dao.queryCustomer();
    // ToDo: revise query subscriptionItem action when api is ready
    //let subscription = dao.querySubscription();
    account = await account;
    customer = await customer;
    //subscription = await subscription;
    //return {account, customer, subscription};
    return {account, customer};
  },
  queryAccount: params =>
    get('/smb-backend/customer/query-account.action', params),
  updateAccount: account =>
    post('/smb-backend/customer/update-account.action', {
      account: {
        id: account.id,
        firstName: account.firstName,
        lastName: account.lastName,
        email: account.email,
        phone: account.phone,
        jobTitle: account.jobTitle,
        languageType: account.languageType,
        isNotificationEnabled: account.isNotificationEnabled,
        image: account.image,
        imageUrl: account.imageUrl,
      },
      password: account.password,
      newPassword: account.newPassword,
      confirmPassword: account.confirmPassword,
    }),
  queryCustomer: () => get('/smb-backend/customer/query-customer.action'),
  updateCustomer: customer =>
    post('/smb-backend/customer/update-customer.action', {customer}),
  updateContact: params =>
    post('/smb-backend/customer/update-billing-contact.action', params),
  listCustomerAccounts: () =>
    get('/smb-backend/customer/list-customer-accounts.action'),
  listStaffs: () => get('/smb-backend/customer/list-staff-accounts.action'),
  listAccountRoles: accountId =>
    get('/smb-backend/customer/list-account-roles.action', {accountId}),
  createStaff: v =>
    post(
      '/smb-backend/customer/create-staff-account.action',
      accountRoleConversionUtils.toDb(v, true)
    ),
  updateStaff: v =>
    post(
      '/smb-backend/customer/update-staff-account.action',
      accountRoleConversionUtils.toDb(v, false)
    ),
  updateTechnicalSupportStatus: () =>
    get('/smb-backend/customer/update-technical-support-status.action'),
  queryTechnicalSupport: () =>
    get('/smb-backend/customer/query-technical-support.action'),
  deleteStaff: accountId =>
    get('/smb-backend/customer/delete-staff-account.action', {accountId}),
  queryAccountEngagement: () =>
    get('/smb-backend/customer/query-account-engagement.action'),
  createAccountEngagement: behaviorType =>
    post('/smb-backend/customer/create-account-engagement.action', {
      behaviorType,
    }),
  sendConfirmEmail: () =>
    get('/smb-backend/customer/send-confirm-email.action'),
  upgradeCustomer: settings =>
    post('/smb-backend/customer/upgrade-customer.action', {
      config: configConversionUtils.toDB(settings),
    }),
  createBeautyAdvisor: data =>
    post('/smb-backend/customer/create-ba-account.action', data),
  updateBeautyAdvisor: data =>
    post('/smb-backend/customer/update-ba-account.action', data),
  deleteBeautyAdvisor: accountId =>
    get('/smb-backend/customer/delete-ba-account.action', accountId),
  createTeamMember: params =>
    post('/smb-backend/customer/create-team-member-account.action', params),
  updateTeamMember: params =>
    post('/smb-backend/customer/update-team-member-account.action', params),
  listTeamMembers: params =>
    post('/smb-backend/customer/list-team-member-accounts.action', params),
  deleteTeamMember: accountId =>
    get('/smb-backend/customer/delete-team-member-account.action', accountId),
  getAccountRoles: params => get('/api/v2/accounts', params),
  getAllAccountRoles: params => paginatedAll('/api/v2/accounts', params),
  queryAccountByConsole: id => get(`/api/v2/accounts/${id}`),
  listTransferableAccounts: () => get('/smb-backend/customer/list-transferable-accounts.action'),
  updateOwner: id =>
    post('/smb-backend/customer/update-team-owner.action', {
      accountId: id,
    }),
};

export default dao;
